import '@/styles/main.scss';

import '@/scripts/main/activity-listing-filter';
import '@/scripts/main/activity-related';
import '@/scripts/main/alerts';
import '@/scripts/main/breadcrumbs';
import '@/scripts/main/cmc-didomi-trigger';
import '@/scripts/main/dropdown-menu';
import '@/scripts/main/english-alert';
import '@/scripts/main/filters';
import '@/scripts/main/forms';
import '@/scripts/main/header-contact-info';
import '@/scripts/main/icon-buttons';
import '@/scripts/main/medias-gallery';
import '@/scripts/main/mobile-menu';
import '@/scripts/main/pagination-enhancer';
import '@/scripts/main/pdf-links';
import '@/scripts/main/popular-requests-carousel';
import '@/scripts/main/popups';
import '@/scripts/main/program-admission-bar';
import '@/scripts/main/promo-header-carousel';
import '@/scripts/main/tooltip';
import '@/scripts/main/user-is-tabbing';

import { Fancybox } from '@fancyapps/ui';
Fancybox.bind( '[data-fancybox]' );

import AOS from 'aos';
import onReady from '@/scripts/modules/on-ready';

onReady( () => {
	AOS.init( {
		startEvent: 'load',
		anchorPlacement: 'top-bottom',
		easing: 'ease-in-cubic',
	} );
} );
